/**
 * Island Rituals Story & Journey Section Scroll Animations
 * Triggers animations when elements come into view
 */

document.addEventListener('DOMContentLoaded', function() {
  // Intersection Observer options
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -100px 0px', // Trigger when element is 100px from bottom of viewport
    threshold: 0.1
  };

  // Create intersection observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Add animate-in class to trigger animations
        entry.target.classList.add('animate-in');
        
        // For story rows, also animate child elements
        if (entry.target.classList.contains('ir-story-row')) {
          const textElement = entry.target.querySelector('.ir-story-text');
          const imageElement = entry.target.querySelector('.ir-story-image');
          
          if (textElement) {
            setTimeout(() => textElement.classList.add('animate-in'), 100);
          }
          if (imageElement) {
            setTimeout(() => imageElement.classList.add('animate-in'), 200);
          }
        }
        
        // For commitment layout, animate child elements
        if (entry.target.classList.contains('ir-commitment-layout')) {
          const contentElement = entry.target.querySelector('.ir-commitment-content');
          const featuresElement = entry.target.querySelector('.ir-commitment-features');
          
          if (contentElement) {
            setTimeout(() => contentElement.classList.add('animate-in'), 200);
          }
          if (featuresElement) {
            setTimeout(() => {
              featuresElement.classList.add('animate-in');
              
              // Animate individual features with stagger
              const features = featuresElement.querySelectorAll('.ir-commitment-feature');
              features.forEach((feature, index) => {
                setTimeout(() => feature.classList.add('animate-in'), 100 * (index + 1));
              });
            }, 300);
          }
        }
        
        // Stop observing once animated
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe all animatable elements
  const elementsToObserve = [
    ...document.querySelectorAll('.ir-story-row'),
    ...document.querySelectorAll('.ir-commitment-layout')
  ];

  elementsToObserve.forEach(element => {
    observer.observe(element);
  });

  // Add reduced motion support
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    // If user prefers reduced motion, add animate-in class immediately
    elementsToObserve.forEach(element => {
      element.classList.add('animate-in');
      
      // Also add to child elements
      const childElements = element.querySelectorAll('.ir-story-text, .ir-story-image, .ir-commitment-content, .ir-commitment-features, .ir-commitment-feature');
      childElements.forEach(child => child.classList.add('animate-in'));
    });
  }
});
